import React, { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";

function pad(n) {
  return n.toString().padStart(2, "0");
}

export default function CountdownTimer({ hours = 36 }) {
  const [target] = useState(() => Date.now() + hours * 60 * 60 * 1000);
  const [now, setNow] = useState(Date.now());
  const { t } = useLang();

  useEffect(() => {
    const tt = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(tt);
  }, []);

  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  const Box = ({ value, label }) => (
    <div className="flex flex-col items-center min-w-[60px] sm:min-w-[80px]">
      <div className="bg-ink text-white font-mono font-bold text-2xl sm:text-3xl px-3 py-2 w-full text-center">
        {pad(value)}
      </div>
      <div className="mt-2 text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">{label}</div>
    </div>
  );

  return (
    <div data-testid="countdown-timer" className="flex items-center gap-2 sm:gap-3">
      <Box value={d} label={t("countdown.days")} />
      <span className="font-display font-black text-xl sm:text-2xl text-ink">:</span>
      <Box value={h} label={t("countdown.hours")} />
      <span className="font-display font-black text-xl sm:text-2xl text-ink">:</span>
      <Box value={m} label={t("countdown.min")} />
      <span className="font-display font-black text-xl sm:text-2xl text-ink">:</span>
      <Box value={s} label={t("countdown.sec")} />
    </div>
  );
}
